<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: "Microsoft YaHei";
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
.allcontant{
   height: auto;
    min-height: calc(100vh - 200px);
  margin-top: 100px;
      /* height: calc(100vh - 280px); */
}
.router-link-active{
      background: rgba(0,0,0,.15);
  color: #00baff !important;
  border-bottom: 6px solid #00baff;
}
.fuwen{
  cursor: pointer !important;
}
td {
    border: 1px solid;
    padding: 5px;
}

@media screen and (max-width:900px){
  .el-message{
    top:100px !important
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue